import { Avatar } from '../../../../components';

const ContactItem = ({ item, onClick }) => {
    return (
        <li onClick={() => onClick(item)}>
            <span className='avatar--'>
                <Avatar
                    name={item?.name}
                    width={'100%'}
                    height={'100%'}
                    fontSize={'1.5rem'}
                />
            </span>
            <span className='info--'>
                <span className='name'>{item?.name}</span>
                <span className='description'>{item?.number_client}</span>
            </span>
        </li>
    );
};

export default ContactItem;